<script lang="ts" setup>
import { ref, watch } from "vue";
import { storeToRefs } from "pinia";
import { useDateRange } from "@/components/DateRange/state.ts";
import MonthPicker from "@/components/DateRange/MonthPicker.vue";

const state = useDateRange();

const emit = defineEmits(["refresh"]);

const { from, to } = storeToRefs(state);

const selectProperty = ref<"from" | "to" | null>(null);

const onChooseMonth = (property: "from" | "to") => {
  selectProperty.value = property;
};

// The window is the six months starting at `from`. Picking a "Tot" before "Van" left `to` behind
// `from`, which emptied the `months` getter and rendered a table with no columns.
const syncRange = () => {
  if (to.value.isBefore(from.value)) {
    to.value = from.value.add(5, "month").endOf("month");
  }

  emit("refresh");
};

watch(from, syncRange);
watch(to, syncRange);
</script>

<template>
  <div class="px-4 relative">
    <!-- Grid wrapper -->
    <div class="-mx-4 flex flex-wrap -space-x-1">
      <!-- Grid column -->
      <div class="w-fit flex flex-col">
        <!-- Column contents -->
        <div class="flex-1">
          <div
            class="rounded-l-md bg-white px-3 pt-2.5 pb-1.5 outline-1 -outline-offset-1 outline-gray-300 focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-indigo-600"
          >
            <label class="block text-xs font-medium text-gray-900" for="from">Van</label>
            <input
              id="from"
              :value="from.format('MMMM YYYY')"
              class="block w-full text-gray-900 placeholder:text-gray-400 focus:outline-none sm:text-sm/6"
              name="from"
              type="text"
              @click="onChooseMonth('from')"
            />
          </div>
        </div>
      </div>
      <!-- Grid column -->
      <div class="w-fit flex flex-col">
        <!-- Column contents -->
        <div class="flex-1">
          <div
            class="rounded-r-md bg-white px-3 pt-2.5 pb-1.5 outline-1 -outline-offset-1 outline-gray-300 focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-indigo-600"
          >
            <label class="block text-xs font-medium text-gray-900" for="to">Tot</label>
            <input
              id="to"
              :value="to.format('MMMM YYYY')"
              class="block w-full text-gray-900 placeholder:text-gray-400 focus:outline-none sm:text-sm/6"
              name="to"
              type="text"
              @click="onChooseMonth('to')"
            />
          </div>
        </div>
      </div>
    </div>
    <MonthPicker
      v-if="selectProperty !== null"
      :property="selectProperty"
      class="absolute w-full -mx-4 mt-2 z-50 shadow-lg"
      @close="selectProperty = null"
    ></MonthPicker>
  </div>
</template>

<style scoped></style>
